import type React from 'react';

// Clicks made inside a marked control; weak so old events are dropped.
const noRowClickEvents = new WeakSet<Event>();

/**
 * Spread on a cell's control so clicking it never opens the row. The click is
 * marked as it happens (capture phase), because the grid reports it after
 * React has re-rendered: a checkbox that saves and closes is gone from the
 * DOM by then, so checking where the click landed would miss it.
 */
export const NO_ROW_CLICK_PROPS = {
  onClickCapture: (event: React.MouseEvent) => {
    noRowClickEvents.add(event.nativeEvent);
  },
};

export const isNoRowClickEvent = (event: Event | null | undefined) =>
  event != null && noRowClickEvents.has(event);
